/*
 * Game state
 * ==========
 *
 * A sample Game state, displaying the Phaser logo.
 */

// music
// https://soundcloud.com/dirtyphonics/anonymous
// https://soundcloud.com/ninjaninja/premiere-fleck-you-got-me-sub-slayers-1
// https://soundcloud.com/ninjaninja/premiere-l-side-heads-or-tails-v-recordings
// https://soundcloud.com/ninjaninja/premiere-roklo-recs-feat-nuklear-evolution-mayan-audio


import Logo from '../objects/Logo';
import Actor from '../objects/Actor';

var myGame = null;

var persistentStatus = {
  musicOn: true,
  playerLevel: 0
};

export default class Game extends Phaser.State {

  preload() {

    // FILTER
    this.usefilter = true;
    this.filter = [];
    this.FILTER_VIGNETTE     = 0;
    this.FILTER_FILMGRAIN    = 1;
    this.FILTER_SNOISE       = 2;
    this.FILTER_SEPIA        = 3;
    this.FILTER_PIXELATE     = 4;

    this.framecount = 0;

    this.levelConfig = [
      // LEVEL 0
      {
        untilTime: 20,
        obstMin: 200,
        obstMax: 320,

      // QUAKE
        quakeMinDuration: 500,
        quakeMaxDuration: 1000,
        quakeMin: 500,
        quakeMax: 1000,
        quakeMinY: 40,
        quakeMaxY: 80,

      // ZOOM
        zoomMin: 20,
        zoomMax: 45,
        zoomMinDelay: 500,
        zoomMaxDelay: 1000,
        zoomMinDuration: 500,
        zoomMaxDuration: 1000,

      // ZOOM
        rotationMin: 180,
        rotationMax: 232,
        rotationMinDelay: 500,
        rotationMaxDelay: 1000,
        rotationMinDuration: 500,
        rotationMaxDuration: 1000

      },

      // LEVEL 1
      {
        untilTime: 40,
        obstMin: 150,
        obstMax: 300,

        // QUAKE
        quakeMinDuration: 500,
        quakeMaxDuration: 1000,
        quakeMin: 500,
        quakeMax: 1000,
        quakeMinY: 50,
        quakeMaxY: 90,

        // ZOOM
        zoomMin: 20,
        zoomMax: 45,
        zoomMinDelay: 500,
        zoomMaxDelay: 1000,
        zoomMinDuration: 500,
        zoomMaxDuration: 1000,

        // ZOOM
        rotationMin: 200,
        rotationMax: 260,
        rotationMinDelay: 500,
        rotationMaxDelay: 1000,
        rotationMinDuration: 500,
        rotationMaxDuration: 1000

      },

      // LEVEL 2
      {
        untilTime: 60,
        obstMin: 120,
        obstMax: 240,

        // QUAKE
        quakeMinDuration: 500,
        quakeMaxDuration: 1000,
        quakeMin: 500,
        quakeMax: 1000,
        quakeMinY: 50,
        quakeMaxY: 90,

        // ZOOM
        zoomMin: 20,
        zoomMax: 45,
        zoomMinDelay: 500,
        zoomMaxDelay: 1000,
        zoomMinDuration: 500,
        zoomMaxDuration: 1000,

        // ZOOM
        rotationMin: 200,
        rotationMax: 260,
        rotationMinDelay: 500,
        rotationMaxDelay: 1000,
        rotationMinDuration: 500,
        rotationMaxDuration: 1000

      },
      
    ];

    this.config = {
      jumpSpeed: -300,
      playerY: 333,
      gravity: 15,
      playerSpeed: 0,
      playerRunAnimSpeed: 8,
      obstWidth: 40,
      obstSpeed: -300,
      cameraXOffs: 320,
      // cameraXOffs: 500,
      cameraYOffs: 240,
      XOffs: 0,

      quakeStartTime: 5,
      zoomStartTime: 15,
      rotationStartTime: 25,
      quakeStartTime2: 35,
      colorStartTime: 45,

  };

    this.status = {

      quakeStarted: false,
      quakeStarted2: false,

      zoomStarted: false,

      rotationStarted: false,

      colorStarted: false,

      paused: true,
      debug: false,

      light: false,

      jumping: {
        active: false,
        speed: 0,
        maxSpeed: 10,
        gravity: 1
      },
      tweens: {
        rotate: null
      },

      quake: null,
      zoom: null,
      rotation: null
    };
    myGame = this;
    this.worldScale = 1;

    this.myRnd = new Phaser.RandomDataGenerator([698435]);
  }

  create() {

    this.game.stage.backgroundColor = '#005353';
    this.game.stage.backgroundColor = '#80ffdb';

    const {centerX: x, centerY: y} = this.world;
    // this.add.existing(new Logo(this.game, x, y));

    // var background = this.add.image(-150, 140, 'background');
    // background.scale.setTo(1,0.2);
    this.game.world.setBounds(0, 0, 4000, this.game.height);
    this.floor   = this.add.tileSprite(0-this.game.world.width/4, this.game.height-120+this.config.XOffs, this.game.world.width*2, 400,'floor');
    this.ceiling = this.add.tileSprite(0-this.game.world.width/4, -100+this.config.XOffs, this.game.world.width*2, 300,'floor');

    this.initCamera();

    this.player = new Actor(this, 100, this.config.playerY+this.config.XOffs, 'player3', 4); /* this.game.world.randomX, this.game.world.randomY); */
    this.player.scale.setTo(0.20);
    this.player.setAnimFrame(2);
    this.add.existing(this.player);

    this.generateObstacles();

    //enable physics on the player and ground
    this.game.physics.arcade.enable(this.player);
    this.player.body.immovable = true;
    this.game.physics.arcade.enable(this.floor);

    //player gravity
    this.player.body.gravity.y = 0;

    //so player can walk on ground
    this.floor.body.immovable = true;
    this.floor.body.allowGravity = false;

    //the camera will follow the player in the world
    this.camera.follow(this.player, null, 0.5, 0.5, 200, -30);

    this.player.body.velocity.x = this.config.playerSpeed;

    // this.status.tweens.rotate = this.game.add.tween(this.player.x).to( 200, 1000, Phaser.Easing.Cubic.InOut, true, 0, true, true);
    // this.status.tweens.rotate = this.game.add.tween(this.game.world.rotation).to( 0.5, 1000, Phaser.Easing.Cubic.InOut, true, 0, true, true);

    //this.startQuakes();
    //this.startRotation();
    //this.startZoom();

    this.initGUI();

  // SOUNDS
  // --------
    this.sounds = {
      music: this.game.add.audio('music1', 0.35, true),
      quake: this.game.add.audio('quake', 1, false),
      whuuup: this.game.add.audio('whuuup', 1, false),
    };
    if (!this.status.light)
      this.sounds.music.play();


  // INPUT
  // ======================
    this.game.input.onDown.add(this._clickDone, this);
    this.game.input.keyboard.addCallbacks(this, null, null, this._keyPress);
    //this.swipe = this.game.input.activePointer;

    this.status.paused = false;

    this.initFilters();

    this.sendEvent('startGame');
  }

  sendEvent(action) {
    if ( ( typeof ga !== 'undefined') && ( ga !== null) ) {
      // console.log('sending', 'send', 'event', 'game', action, 'LD', this.gamenumber);
      ga('send', 'event', 'game', action);//, 'LD', this.gamenumber);
    }
  }


  initFilters() {
    this.filter[this.FILTER_FILMGRAIN] = this.game.add.filter('FilmGrain');
    this.filter[this.FILTER_FILMGRAIN].color = 0.6;
    this.filter[this.FILTER_FILMGRAIN].amount = 0.08;
    this.filter[this.FILTER_FILMGRAIN].luminance = 0.8;

    this.filter[this.FILTER_VIGNETTE] = this.game.add.filter('Vignette');
    this.filter[this.FILTER_VIGNETTE].size = 0.5;
    this.filter[this.FILTER_VIGNETTE].amount = 0.45;
    this.filter[this.FILTER_VIGNETTE].alpha = 0.9;

    this.game.stage.filters = [
      this.filter[this.FILTER_FILMGRAIN],
      // this.filter[this.FILTER_SEPIA],
      this.filter[this.FILTER_VIGNETTE]
    ];
  }

  initGUI() {
    this.startTime = Date.now();
    this.lastTime = 0;

    this.scratches = 0;
    this.wraps = 0;
    this.points = 0;
    this.wrapping = true;
    this.stopped = false;
    this.maxScratches = 5;

    //stats
    var style1 = { font: "20px Arial", fill: "#ffffff"};
    var style2 = { font: "20px Arial", fill: "#ffffff"};

    this.text1 = this.game.add.text(320+10 +40, 240+10 +40, "Time:", style1);
    this.text2 = this.game.add.text(320+400, 240+10 +40, "Level:", style1);

    this.text1.fixedToCamera = true;
    this.text2.fixedToCamera = true;

    this.timeText = this.game.add.text(320+80 +40, 240+10 +40, "", style1);
    this.levelText = this.game.add.text(320+480, 240+10 +40, "", style2);

    this.refreshStats();
    this.timeText.fixedToCamera = true;
    this.levelText.fixedToCamera = true;
  }

  refreshStats() {
    var nutime = Math.round( (Date.now() - this.startTime) / 100);
    if (nutime != this.lastTime) {
      this.lastTime = nutime;
      this.timeText.text = nutime / 10;
      this.levelText.text = persistentStatus.playerLevel+1;
    }
  }

  initCamera() {

    // we need to add margin to the world, so the camera can move
    var margin = 500;
    // and set the world's bounds according to the given margin
    var x = -margin;
    var y = -margin;
    var w = this.game.world.width + margin * 2;
    var h = this.game.world.height + margin * 2;
    // it's not necessary to increase height, we do it to keep uniformity
    this.game.world.setBounds(x, y, w, h);

    this.game.world.pivot.setTo(this.config.cameraXOffs, this.config.cameraYOffs);
    //this.game.world.camera.position.set(400,400);
    this.game.camera.x = -this.config.cameraXOffs;
    this.game.camera.y = -this.config.cameraYOffs;
  }


  pauseGame() {
    this.status.paused = true;
    this.game.paused = true;
    this.sounds.music.pause();

    if (this.status.quakeStarted)
      this.stopQuakes();

    if (this.status.zoomStarted) {
      this.stopZoom();
    }

    if (this.status.rotationStarted) {
      this.stopRotation();
    }

    // Then add the menu
    this.menu = this.game.add.sprite(this.config.cameraXOffs - 5, this.config.cameraYOffs + 30, 'menu2');
    this.menu.anchor.setTo(0.5, 0.5);
    this.menu.scale.setTo(0.5);

    // And a label to illustrate which menu item was chosen. (This is not necessary)
    var w = 640, h = 480;
    this.refreshStats();
    var choiseLabel1 = this.game.add.text(w/2, h-300, 'Ouch, that hurt!' , { font: '30px Arial', fill: '#fff' });
    choiseLabel1.anchor.setTo(0.5, 0.5);
    var choiseLabel = this.game.add.text(w/2 + 1, h-220,
        'You survived '+(this.lastTime/10)+' seconds, well done!\n But can you do better? ;)', { font: '22px Arial', fill: '#fff' });
    choiseLabel.anchor.setTo(0.5, 0.5);
    var restartLabel = this.game.add.text(w/2, h-130, 'Click to restart', { font: '30px Arial', fill: '#fff' });
    restartLabel.anchor.setTo(0.5, 0.5);

    this.sendEvent('stopGame');
  }

  playerStuck(player, obstacle) {
    //console.log('stuck', player, obstacle);
    this.pauseGame();
  }


  update() {

    if (!this.status.paused) {
      this.refreshStats();

      this.updateObstacles();

      this.updateEffects();

      persistentStatus.playerLevel = Math.floor(this.lastTime / 200);

      if (persistentStatus.playerLevel > (this.levelConfig.length-1))
        persistentStatus.playerLevel = (this.levelConfig.length-1);

      this.game.physics.arcade.collide(this.player, this.floor, this.playerHit, null, this);
      if (!this.status.light)
        this.game.physics.arcade.collide(this.player, this.obstacles, this.playerStuck, null, this);
      // this.game.physics.arcade.overlap(this.player, this.mounds, this.collect, this.checkDig, this);

      if (this.player.position.y < this.config.playerY) {
        this.player.body.velocity.y += this.config.gravity;
      } else {
        this.player.position.y = this.config.playerY;
        this.player.body.velocity.y = 0;
        this.status.jumping.active = false;
      }

      this.framecount++;
      this.framecount = this.framecount % 3;

      if (this.usefilter && this.framecount == 0)
        this.filter[this.FILTER_FILMGRAIN].update();
    }


    // movement

    //http://jsfiddle.net/lewster32/NMNJ7/
    if (this.game.input.keyboard.isDown(Phaser.Keyboard.UP)) {
      // this.game.world.pivot.y -= speed;
      //this.player.goUp();
      console.log('up');

      if (!this.status.jumping.active) {
        this.status.jumping.active = true;
        this.player.body.velocity.y = this.config.jumpSpeed;
      }

    }
    else if (this.game.input.keyboard.isDown(Phaser.Keyboard.DOWN)) {
      // this.game.world.pivot.y += speed;
      //this.player.goDown();
      console.log('down');
      if (this.player.position.y < this.config.playerY) {
        this.player.body.velocity.y += this.config.gravity*1;
      }
    }
    if (this.game.input.keyboard.isDown(Phaser.Keyboard.LEFT)) {
      // this.game.world.pivot.x -= speed;
      //this.player.goLeft();
      console.log('left');
      this.game.world.rotation -= 0.01;
    }
    else if (this.game.input.keyboard.isDown(Phaser.Keyboard.RIGHT)) {
      // this.game.world.pivot.x += speed;
      //this.player.goRight();
      console.log('right');
      this.game.world.rotation += 0.01;
    }


    // ZOOM WORLD
    // ================================
    if (this.status.debug) {
      if (this.game.input.keyboard.isDown(Phaser.Keyboard.E)) {
        this.worldScale += 0.03;
      }
      else if (this.game.input.keyboard.isDown(Phaser.Keyboard.A)) {
        this.worldScale -= 0.03;
      }
      else if (this.game.input.keyboard.isDown(Phaser.Keyboard.O)) {
        this.worldScale = 1;

        this.game.camera.x = -this.config.cameraXOffs;
        this.game.camera.y = -this.config.cameraYOffs;
      }

      this.worldScale = Phaser.Math.clamp(this.worldScale, 0.2, 2.5);
      // set our world scale as needed
      this.game.world.scale.set( this.worldScale );

    }

  }


  updateObstacles() {
    this.lastObstacle -= this.config.obstSpeed;
    //var x = this.lastObstacle + this.myRnd.integerInRange(this.levelConfig[persistentStatus.playerLevel].obstMin, this.levelConfig[persistentStatus.playerLevel].obstMax);
    this.lastObstacle = 0;
    this.obstacles.forEach(function(item) {
      if (item.x > this.lastObstacle)
        this.lastObstacle = item.x + this.config.obstWidth;
    }, this);

    this.obstacles.forEach(function(item) {
      if (item.x < -300) {
        // console.log(this.myRnd.integerInRange(this.levelConfig[persistentStatus.playerLevel].obstMin, this.levelConfig[persistentStatus.playerLevel].obstMax));
        var x = this.lastObstacle + this.myRnd.integerInRange(this.levelConfig[persistentStatus.playerLevel].obstMin, this.levelConfig[persistentStatus.playerLevel].obstMax);
        this.lastObstacle = x + this.config.obstWidth;
        item.x = x;
      }
    }, this);
  }

  generateObstacles() {
    this.obstacles = this.game.add.group();

    //enable physics in them
    this.obstacles.enableBody = true;

    //phaser's random number generator
    var mound;

    this.lastObstacle = this.game.width + this.config.obstWidth;

    for (var i = 0; i < 10; i++) {
      var x = this.lastObstacle + this.myRnd.integerInRange(this.levelConfig[persistentStatus.playerLevel].obstMin, this.levelConfig[persistentStatus.playerLevel].obstMax);
      this.lastObstacle = x + this.config.obstWidth;
      if (this.myRnd.integerInRange(1, 2) == 1) {
        mound = this.obstacles.create(x, this.game.height - 120 - 28, 'zombie1');
      } else {
        mound = this.obstacles.create(x, this.game.height - 120 - 28, 'zombie2');
      }
      mound.scale.setTo(0.18,0.2);
      mound.body.velocity.x = this.config.obstSpeed;
      mound.body.immovable = true;
      mound.body.collideWorldBounds = false;
    }
  }

  _keyPress(char) {
    this._restart();
  }

  _clickDone(pointer) {
    this._restart();
  }

  _restart() {
    if (this.status.paused) {
      this.status.paused = false;
      this.game.paused = false;
      this.sendEvent('restartGame');
      this.state.start('Game');
    }
  }










  // ====================================================================================
  //                                  EFFECTS
  // ====================================================================================


  updateEffects() {

    // Zoom
    if ((this.lastTime > (this.config.rotationStartTime * 10)) && !this.status.rotationStarted) {
      if (this.status.debug)
        console.log('Starting rotation');
      this.status.rotationStarted = true;
      this.startRotation();
    }

    // Rotation
    if ((this.lastTime > (this.config.zoomStartTime * 10)) && !this.status.zoomStarted) {
      if (this.status.debug)
        console.log('Starting zoom');
      this.status.zoomStarted = true;
      this.startZoom();
    }

    // Quake 1
    if ((this.lastTime > (this.config.quakeStartTime * 10)) && !this.status.quakeStarted) {
      if (this.status.debug)
        console.log('Starting quakes');
      this.status.quakeStarted = true;
      this.startQuakes();
    }
    // Quake 2
    if ((this.lastTime > (this.config.quakeStartTime2 * 10)) && !this.status.quakeStarted2) {
      if (this.status.debug)
        console.log('Starting quakes');
      this.status.quakeStarted2 = true;
      this.startQuakes();
    }
  }



  // =======================================
  //                 QUAKES
  // =======================================

  startQuakes() {
    this.addQuake();
  }

  stopQuakes() {
    this.status.quake.pause();
  }

  addQuake() {

    // define the camera offset for the quake
    var rumbleOffsetX =
        this.myRnd.integerInRange(
        this.levelConfig[persistentStatus.playerLevel].quakeMinY,
        this.levelConfig[persistentStatus.playerLevel].quakeMaxY);
    var rumbleOffsetY =
        this.myRnd.integerInRange(
            this.levelConfig[persistentStatus.playerLevel].quakeMinY,
            this.levelConfig[persistentStatus.playerLevel].quakeMaxY);

    // we need to move according to the camera's current position
    var properties = {
      x: this.game.camera.x - rumbleOffsetX,
      y: this.game.camera.y - rumbleOffsetY
    };

    // we make it a really fast movement
    var duration =
        this.myRnd.integerInRange(
            this.levelConfig[persistentStatus.playerLevel].quakeMinDuration,
            this.levelConfig[persistentStatus.playerLevel].quakeMaxDuration);

    // because it will repeat
    var repeat = this.myRnd.integerInRange(2, 6);

    // we use bounce in-out to soften it a little bit
    var ease = Phaser.Easing.Bounce.InOut;
    var autoStart = false;
    // a little delay because we will run it indefinitely
    var delay =
        this.myRnd.integerInRange(
            this.levelConfig[persistentStatus.playerLevel].quakeMin,
            this.levelConfig[persistentStatus.playerLevel].quakeMax);
    // we want to go back to the original position
    var yoyo = true;

    if (this.status.debug)
      console.log('New quake in '+delay, repeat, properties);

    this.status.quake = this.game.add.tween(this.game.camera)
        .to(properties, duration, ease, autoStart, delay, repeat, yoyo);

    //console.log(repeat, delay);

    // we're using this line for the example to run indefinitely
    this.status.quake.onComplete.addOnce(function(){
      myGame.addQuake();
    });

    // let the earthquake begins
    this.status.quake.start();

    this.sounds.quake.play();
  }






  // =======================================
  //                 ZOOM
  // =======================================
  startZoom() {
    //http://www.html5gamedevs.com/topic/7150-how-to-zoom-out-from-center-of-gameworld/
    // http://jsfiddle.net/lewster32/NMNJ7/
    this.addZoom();
    this.status.zoomStarted = true;
  }

  stopZoom() {
    this.status.zoom.pause();
    this.status.zoomStarted = false;
    this.game.world.scale.set(1);
  }

  addZoom() {

    // define the camera offset for the quake
    var zoomOffset =
        this.myRnd.integerInRange(
            this.levelConfig[persistentStatus.playerLevel].zoomMin,
            this.levelConfig[persistentStatus.playerLevel].zoomMax);

    // we need to move according to the camera's current position
    var properties = {
      x: 1 + zoomOffset / 100,
      y: 1 + zoomOffset / 100,
    }
    // if (Math.random() > 0.5) {
    //   delete properties.x;
    // } else {
    //   delete properties.y;
    // }

    // we make it a really fast movement
    var duration = this.myRnd.integerInRange(
        this.levelConfig[persistentStatus.playerLevel].zoomMinDuration,
        this.levelConfig[persistentStatus.playerLevel].zoomMaxDuration);

    // because it will repeat
    var repeat = this.myRnd.integerInRange(1, 3);

    // we use bounce in-out to soften it a little bit
    var ease = Phaser.Easing.Sinusoidal.InOut;
    var autoStart = false;

    // a little delay because we will run it indefinitely
    var delay =
        this.myRnd.integerInRange(
            this.levelConfig[persistentStatus.playerLevel].zoomMinDelay,
            this.levelConfig[persistentStatus.playerLevel].zoomMaxDelay);

    // we want to go back to the original position
    var yoyo = true;

    if (this.status.debug)
      console.log('New zoom in '+delay, repeat, properties);

    this.status.zoom = this.game.add.tween(this.game.world.scale)
        .to(properties, duration, ease, autoStart, delay, repeat, yoyo);

    //console.log(repeat, delay);

    // we're using this line for the example to run indefinitely
    this.status.zoom.onComplete.addOnce(function(){
      myGame.addZoom();
    });

    // let the earthquake begins
    this.status.zoom.start();

    this.sounds.whuuup.play();
  }





  // =======================================
  //                 ROTATION
  // =======================================
  startRotation() {
    //http://www.html5gamedevs.com/topic/7150-how-to-zoom-out-from-center-of-gameworld/
    // http://jsfiddle.net/lewster32/NMNJ7/
    this.addRotation();
    this.status.rotationStarted = true;
  }

  stopRotation() {
    this.status.rotation.pause();
    this.status.rotationStarted = false;
    this.game.world.rotation = 0;
  }

  addRotation() {

    // define the camera offset for the quake
    var rotationOffset =
        this.myRnd.integerInRange(
            this.levelConfig[persistentStatus.playerLevel].rotationMin,
            this.levelConfig[persistentStatus.playerLevel].rotationMax);

    var dir = this.myRnd.integerInRange(1, 2);

    // we need to move according to the camera's current position
    var properties = 0;
    if (dir == 1) {
      properties = {
        rotation: this.game.world.rotation + rotationOffset / 1000
      }
    } else {
      properties = {
        rotation: this.game.world.rotation - rotationOffset / 1000
      }
    }

    // we make it a really fast movement
    var duration = this.myRnd.integerInRange(
        this.levelConfig[persistentStatus.playerLevel].rotationMinDuration,
        this.levelConfig[persistentStatus.playerLevel].rotationMaxDuration);

    // because it will repeat
    var repeat = this.myRnd.integerInRange(2, 4);

    // we use bounce in-out to soften it a little bit
    var ease = Phaser.Easing.Bounce.InOut;
    var autoStart = false;

    // a little delay because we will run it indefinitely
    var delay =
        this.myRnd.integerInRange(
            this.levelConfig[persistentStatus.playerLevel].rotationMinDelay,
            this.levelConfig[persistentStatus.playerLevel].rotationMaxDelay);

    // we want to go back to the original position
    var yoyo = true;

    if (this.status.debug)
      console.log('New rotation in '+delay, repeat, properties);

    this.status.rotation = this.game.add.tween(this.game.world)
        .to(properties, duration, ease, autoStart, delay, repeat, yoyo);

    //console.log(repeat, delay);

    // we're using this line for the example to run indefinitely
    this.status.rotation.onComplete.addOnce(function(){
      myGame.addRotation();
    });

    // let the earthquake begins
    this.status.rotation.start();
  }



}
